<div class="cardBloque mb-2">
    <h1 style="text-align: center; color: black; font-weight: bolder;" class="titlesSize">EVENTOS</h1>

    <h3 style="text-align: center; color: black;  font-weight: bolder;" class="subtitlesSize">Próximos</h3>
    <div class="row" *ngIf="eventsFuture && eventsFuture.length>0">
        <div class="col-md-4" *ngFor="let evFu of paginatedFutureEvents">
            <div class="card colorLandingCard">
                <div class="card-body">
                    <img class="img-responsiva  img-fluid " [src]="url + evFu.image" alt="banner">
                    <div class="containTextEventTitle">
                        <h3 class="text-center text-primary mt-1">{{evFu.title}}</h3>
                    </div>

                    <div class="containTextEvent">
                        <p class="card-text mt-1 ">
                            {{evFu.description}}
                        </p>
                        <p *ngIf="evFu.hora_inicio" class="card-text mt-1 ">
                            {{evFu.hora_inicio}} {{evFu.hora_fin}}
                        </p>
                    </div>

                    <div class="d-flex justify-content-center mt-1" *ngIf="evFu.linkFacebook">
                        <button type="button" class="btn btn-primary" style="border-radius: 20px;" rippleEffect
                            (click)="redirectEventLink(evFu.linkFacebook)">
                            <span [data-feather]="'facebook'" [class]="'mr-25'"></span>Ver en
                            facebook</button>
                    </div>
                    <div class="d-flex justify-content-center mt-1" *ngIf="evFu.linkVideo">
                        <button type="button" class="btn btn-primary" style="border-radius: 20px;" rippleEffect
                            (click)="redirectEventLink(evFu.linkVideo)">
                            <span [data-feather]="'youtube'" [class]="'mr-25'"></span>Ver video </button>
                    </div>

                    <div class="d-flex justify-content-center mt-1">
                        <button type="button" class="btn btn-primary" style="border-radius: 20px;" rippleEffect
                            (click)="handleUpdateEventClick2(evFu.id)">
                            <span [data-feather]="'youtube'" [class]="'mr-25'"></span>Ver Evento </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-md-6 text-center">
            <button class="btn btn-primary" (click)="goToPage(currentPage - 1)"
                [disabled]="currentPage === 1">Anterior</button>
        </div>
        <div class="col-md-6 text-center">
            <button class="btn btn-primary" (click)="goToPage(currentPage + 1)"
                [disabled]="currentPage * pageSize >= paginatedFutureEvents.length">Siguiente</button>
        </div>
    </div>
    <ng-container *ngIf="paginatedFutureEvents.length === 0">
        <h3 class="mt-1 text-center">No hay eventos próximos</h3>
    </ng-container>

    <br>
    <br>
    <h3 style="text-align: center; color: black;  font-weight: bolder;" class="subtitlesSize">Pasados</h3>
    <div class="row" *ngIf="eventsPast && eventsPast.length>0">
        <div class="col-md-4" *ngFor="let evePas of paginatedPastEvents">
            <div class="card colorLandingCard">

                <div class="card-body">
                    <img class="img-responsiva  img-fluid " [src]="url + evePas.image" alt="banner">
                    <div class="containTextEventTitle">
                        <h3 class="text-center text-primary mt-1">{{evePas.title}}</h3>
                    </div>
                    <div class="containTextEvent">
                        <p class="card-text mt-1 ">
                            {{evePas.description}}
                        </p>
                        <!-- <p *ngIf="evePas.hora_inicio" class="card-text mt-1 ">
                            {{evPas.hora_inicio}} - {{evPas.hora_fin}}
                        </p> -->
                    </div>

                    <div class="d-flex justify-content-center  mt-1" *ngIf="evePas.linkFacebook">
                        <button type="button" class="btn btn-primary" style="border-radius: 20px;" rippleEffect
                            (click)="redirectEventLink(evePas.linkFacebook)">
                            <span [data-feather]="'facebook'" [class]="'mr-25'"></span>Ver en
                            facebook</button>
                    </div>
                    <div class="d-flex justify-content-center mt-1" *ngIf="evePas.linkVideo">
                        <button type="button" class="btn btn-primary" style="border-radius: 20px;" rippleEffect
                            (click)="redirectEventLink(evePas.linkVideo)">
                            <span [data-feather]="'youtube'" [class]="'mr-25'"></span>Ver video </button>
                    </div>
                    <div class="d-flex justify-content-center mt-1" *ngIf="evePas.linkVideo">
                        <button type="button" class="btn btn-primary" style="border-radius: 20px;" rippleEffect
                            (click)="handleUpdateEventClick2(evePas.id)">Ver evento </button>
                    </div>
                </div>

            </div>
        </div>
    </div>

    <div class="row">
        <div class="col-md-6 text-center">
            <button class="btn btn-primary" (click)="goToPage2(currentPage2 - 1)"
                [disabled]="currentPage2 === 1">Anterior</button>
        </div>
        <div class="col-md-6 text-center">
            <button class="btn btn-primary" (click)="goToPage2(currentPage2 + 1)"
                [disabled]="currentPage2 * pageSize >= paginatedPastEvents.length">Siguiente</button>
        </div>
    </div>

    <ng-container *ngIf="paginatedPastEvents.length === 0">
        <h3 class="mt-1 text-center">No hay eventos pasados</h3>
    </ng-container>

    <h1 class="text-center mt-3">Calendario</h1>
    <div class="app-calendar overflow-hidden border ">
        <div class="row no-gutters">
            <!-- calendar main sidebar -->
            <core-sidebar class="col app-calendar-sidebar flex-grow-0 overflow-hidden d-flex flex-column"
                name="calendar-main-sidebar" overlayClass="body-content-overlay" collapsibleSidebar="bs-gt-lg">
                <app-calendar-main-sidebar (filtrado)="filter($event)"></app-calendar-main-sidebar>
            </core-sidebar>
            <!--/ calendar main sidebar -->

            <!-- calendar -->
            <div class="col position-relative">
                <div class="card shadow-none border-0 mb-0 rounded-0">
                    <div class="card-body pb-0">
                        <full-calendar [options]="calendarOptions"></full-calendar>

                    </div>
                </div>
            </div>
            <!-- calendar -->
        </div>
    </div>

    <!-- <div class="row mt-5">
        <div class="col-md-12 text-center">
            <a href="/eventos" class="btn btn-primary">Ver Mas...</a>
        </div>
    </div> -->
</div>

<!-- Modal -->
<ng-template #modalVC let-modal>
    <div class="modal-header">
        <h5 class="modal-title" id="exampleModalCenterTitle">Evento</h5>
        <button type="button" class="close" (click)="modal.dismiss('Cross click')" aria-label="Close">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body" tabindex="0" ngbAutofocus>

        <div class="container-fluid">
            <div class="row justify-content-center">
                <div class="col-auto">
                    <img [src]=" url+eventModel.image" alt="" height="200px" style="border-radius: 25px;">
                </div>
            </div>

            <div class="row mt-1">
                <div class="col-12 text-center ">
                    <h2 class="text-primary">{{eventModel.title}}</h2>
                </div>
            </div>

            <div class="row mt-1">
                <div class="col-12 text-center ">
                    <span>{{eventModel.description}}</span>
                </div>
            </div>

            <div class="row mt-1 justify-content-center">
                <div class="col-auto">
                    <button type="button" class="btn btn-relief-primary btn-block round " rippleEffect
                        (click)="redirectEventLink(eventModel.linkFacebook)" style="width: 220px;">
                        <span [data-feather]="'facebook'" class="m-0 p-0" size="15"></span>
                        Ver en facebook</button>
                </div>
            </div>

            <div class="row mt-1 justify-content-center">
                <div class="col-auto">
                    <button type="button" class="btn btn-relief-primary btn-block round " rippleEffect
                        (click)="redirectEventLink(eventModel.linkVideo)" style="width: 220px;">
                        <span [data-feather]="'play'" class="m-0 p-0" size="15"></span>
                        Ver video</button>
                </div>
            </div>

            <div style="position: fixed; bottom: 20px; right: 20px; z-index: 1000;">
                <button type="button" class="btn btn-icon rounded-circle colorWhatsApp" (click)="sendWhatsapp()"
                    style="font-size: 25px; background-color: #25D366; color: white;">
                    <i class="fa fa-whatsapp" aria-hidden="true"></i>
                </button>
            </div>






        </div>


    </div>
</ng-template>